import { H6 } from "@coherehealth/common";
import { ButtonBase, Box } from "@mui/material";
import { User } from "@sentry/react";
import { UserContext } from "UserContext";
import useLogout from "hooks/useLogout";
import { useState, useContext, useEffect } from "react";
import { useQmNavigationStyles } from "./qmNavigationStyles";
import { QueueViewState } from "@coherehealth/qm-api";

export type LogoutItemProps = {
  queueViewState: QueueViewState;
};

export const LogoutItem = ({ queueViewState }: LogoutItemProps) => {
  const classes = useQmNavigationStyles({ queueViewState });
  const [currentUser, setCurrentUser] = useState<User>();
  const { getUser } = useContext(UserContext);
  const logout = useLogout();
  useEffect(() => {
    getUser().then((currentUser) => {
      setCurrentUser(currentUser);
    });
  }, [getUser]);
  const userInitials = `${currentUser?.given_name ? currentUser?.given_name[0] : ""}${
    currentUser?.family_name ? currentUser?.family_name[0] : ""
  }`;
  const label = userInitials ?? "Logout";

  return currentUser ? (
    <ButtonBase className={classes.buttonContainer} onClick={() => logout()} data-testid="qm-button-logout">
      <Box className={classes.logoutButton}>
        <H6 className={classes.logoutDisplay}>{label}</H6>
      </Box>
    </ButtonBase>
  ) : null;
};
